angular.module("survey").factory("analytics", ["$window", analytics])

function analytics($window) {

    var _customEvent = function(event, options) {
        var dataLayer = $window.dataLayer;
        var gtmEvent = { event: event };
        // If we got other messages, include them here
        var gtmEventPayload = options ? Object.assign(gtmEvent, options) : gtmEvent;

        // actually push the event and message to the DataLayer
        if (dataLayer) dataLayer.push(gtmEventPayload)
    }
    return {
        customEvent: _customEvent
    };
} 